/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './localized_addon';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "data": {
            "nested": {
              "AddonMetadata": {
                "fields": {
                  "addonId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "localizedName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "localizedShortFormDescription": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "saasAddonSpecificDetails": {
                    "type": ".squareup.addons.data.LocalizedAddon.SaasAddonSpecificDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "subscriptionRequirement": {
                    "type": ".squareup.addons.data.SubscriptionRequirement",
                    "id": 5,
                    "rule": "optional"
                  },
                  "iconUrl": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "smallIconUrl": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "publishedVerticals": {
                    "type": ".squareup.addons.data.LocalizedVertical",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "details": {
                    "type": ".squareup.addons.data.LocalizedAddon.LocalizedAddonDetails",
                    "id": 10,
                    "rule": "optional"
                  },
                  "addonImplType": {
                    "type": ".squareup.addons.data.AddonImplementationType",
                    "id": 11,
                    "rule": "optional"
                  },
                  "slotAddonMetadata": {
                    "type": ".squareup.addons.data.SlotAddonMetadata",
                    "id": 12,
                    "rule": "optional"
                  },
                  "webAddonMetadata": {
                    "type": ".squareup.addons.data.WebAddonMetadata",
                    "id": 13,
                    "rule": "optional"
                  },
                  "developer": {
                    "type": ".squareup.addons.data.Developer",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "AddonImplementationType": {
                "values": {
                  "ADDON_IMPLEMENTATION_UNKNOWN": 0,
                  "BUILT_IN_NATIVE": 1,
                  "SLOT_WEB": 2,
                  "SLOT_NATIVE": 3
                }
              },
              "Developer": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isThirdParty": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "authenticationLink": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SlotAddonMetadata": {
                "fields": {
                  "localizedShortName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "WebAddonMetadata": {
                "fields": {
                  "baseUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "registeredViewUrls": {
                    "type": "string",
                    "id": 2,
                    "keyType": "string"
                  },
                  "registeredQueryUrls": {
                    "type": "string",
                    "id": 3,
                    "keyType": "string"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AddonMetadata && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AddonImplementationType && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.Developer && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.SlotAddonMetadata && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.WebAddonMetadata) {
  $root.addJSON(jsonData);
}

/**
 * This resource holds information about the add-on that is not specific to the seller/device and is
 * not likely to change frequently, such as its ID and subscription requirement. It will also
 * include localized strings which are chosen based on the location from request headers, as
 * localized text is still considered a subset of the metadata, even though the specific strings
 * included can vary for different callers.
 *
 * SOURCE AddonMetadata @ squareup/addons/data/addon_metadata.proto at 16:1
 */
export const AddonMetadata = $root.lookupType('squareup.addons.data.AddonMetadata');
fixType(AddonMetadata, {
  addonId: {
    notEmpty: true
  },
  localizedName: {
    notEmpty: true
  },
  localizedShortFormDescription: {
    notEmpty: true
  },
  subscriptionRequirement: {
    required: true
  },
  details: {
    required: true
  },
  addonImplType: {
    required: true
  },
  developer: {
    required: true
  }
});
Builder.createAndAttachToType(AddonMetadata);
/**
 * SOURCE AddonImplementationType @ squareup/addons/data/addon_metadata.proto at 67:1
 */
export const AddonImplementationType = $root.lookupEnum('squareup.addons.data.AddonImplementationType').values;
/**
 * SOURCE Developer @ squareup/addons/data/addon_metadata.proto at 78:1
 */
export const Developer = $root.lookupType('squareup.addons.data.Developer');
fixType(Developer, {
  name: {
    notEmpty: true
  },
  isThirdParty: {
    required: true
  }
});
Builder.createAndAttachToType(Developer);
/**
 * SOURCE SlotAddonMetadata @ squareup/addons/data/addon_metadata.proto at 91:1
 */
export const SlotAddonMetadata = $root.lookupType('squareup.addons.data.SlotAddonMetadata');
fixType(SlotAddonMetadata);
Builder.createAndAttachToType(SlotAddonMetadata);
/**
 * SOURCE WebAddonMetadata @ squareup/addons/data/addon_metadata.proto at 124:1
 */
export const WebAddonMetadata = $root.lookupType('squareup.addons.data.WebAddonMetadata');
fixType(WebAddonMetadata, {
  baseUrl: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WebAddonMetadata);